import { Routes, Route } from "react-router-dom";
import Register from "../Pages/Auth/Register";
import Login from "../Pages/Auth/Login";
import ForgetPassword from "../Pages/Auth/ForgetPassword";
import VerifyOTP from "../Pages/Auth/VerifyOTP";
import ResetPassword from "../Pages/Auth/ResetPassword";
import Home from "../Pages/Dashboard/Home";
import Profile from "../Pages/Users/Profile";
import ProtectedRoute from "./ProtectedRoute";
import UsersList from "../Pages/Users/UsersList";
import Transactions from "../Pages/Wallet/Transactions";
import Services from "../Pages/Services/Services";
import ServicesTransactions from "../Pages/Services/ServicesTransactions";
import Dashboard from "../Pages/Dashboard/Dashboard";
import Reports from "../Pages/Reports/Reports";
import LandingPage from "../Pages/Dashboard/LandingPage";
import MyServices from "../Pages/Services/Service Management/MyServices";
import AdminTransactionsPage from "../Pages/Admin/AdminTransactionsPage";
import AdminWalletsPage from "../Pages/Admin/AdminWalletsPage";
// import LandingPage from "../Pages/LandingPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-otp" element={<VerifyOTP />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/home"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/merchants"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <UsersList />
          </ProtectedRoute>
        }
      />
      <Route
        path="/wallet-transactions"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <Transactions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/services-transactions"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <ServicesTransactions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/mtn-syriatel-operations"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <Services />
          </ProtectedRoute>
        }
      />
      <Route
        path="/service-management"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <MyServices />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <Reports />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-transactions"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <AdminTransactionsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-wallets"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <AdminWalletsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route path="/forgetPassword" element={<ForgetPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
} 
